export const __actionTypes = {
  SET_AUTH_STATE_DATA: "[SET_AUTH_STATE_DATA] Action",
  UPDATE_AUTH_STATE_DATA: "[UPDATE_AUTH_STATE_DATA] Action",
  RESET_AUTH_STATE_DATA: "[RESET_AUTH_STATE_DATA] Action",
};

const __initialState = {
  data: {},
};

export const reducer = (state = __initialState, action) => {
  switch (action.type) {
    case __actionTypes.SET_AUTH_STATE_DATA: {
      const data = action.payload;
      return { data: data };
    }

    case __actionTypes.UPDATE_AUTH_STATE_DATA: {
      const data = action.payload;
      return { data: { ...state.data, ...data } };
    }

    case __actionTypes.RESET_AUTH_STATE_DATA: {
      return { data: {} };
    }

    default:
      return state;
  }
};

export const AuthStateActions = {
  SET_AUTH_STATE_DATA: (payload) => ({
    type: __actionTypes.SET_AUTH_STATE_DATA,
    payload,
  }),
  UPDATE_AUTH_STATE_DATA: (payload) => ({
    type: __actionTypes.UPDATE_AUTH_STATE_DATA,
    payload,
  }),
  RESET_AUTH_STATE_DATA: () => ({ type: __actionTypes.RESET_AUTH_STATE_DATA }),
};
